<template>
    <div>
        <hr/>
        <div class="form-group">
            <a
                :href="`/admin/${activeEmd.slug}/subscriptions.csv?filter=${statusFilter}`"
                class="btn btn-secondary pull-right"
            >
                Download .CSV
            </a>
            <label class="padding-bottom-10">Filter by Status</label>
            <div v-for="group in statusGroups" class="investment-status">
                <label class="investment-table-label">
                    {{ group.name }}:
                </label>
                <span
                    v-for="(label, status) in group.statuses"
                    @click="statusFilter = status"
                >
                    <a
                        class="btn btn-default investment-button"
                        :class="{active: statusFilter === status}"
                    >
                        {{ label }}
                    </a>
                </span>
            </div>
        </div>
        <hr/>

        <div class="form-group col-md-4 row">
            <label class="padding-bottom-10">Filter by User</label>
            <input type="text" v-model="search" class="form-control">
        </div>

        <table class="table">
            <thead>
                <tr>
                    <th
                        v-for="(column,label) in columns"
                        @click="sort(label)"
                    >
                        {{ column.label }}
                    </th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="investment in filteredInvestments">
                    <td>{{ statusString(investment.status) }}</td>
                    <td class="text-right">{{ money(investment.amount) }}</td>
                    <td v-if="investment.offering.emd.is_non_brokered">
                        {{ date(investment.signed_on) }}
                    </td>
                    <td v-else="investment.offering.emd.is_community_coop">
                        {{ date(investment.client_application.signed_on) }}
                    </td>
                    <td>{{ investment.offering.name }}</td>
                    <td>{{ investment.investor.full_name }}</td>
                    <td>{{ investment.subscriber_name }}</td>
                    <td>
                        <a
                            :href="`/admin/${investment.offering.emd.slug}/subscriptions/${investment.id}`"
                            class="btn btn-default btn-xs"
                            @click="saveFilter(statusFilter)"
                        >
                            View
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
  import accounting from "accounting"
  import moment from "moment"

  function by(getValue, dir) {
    return (a, b) => {
      let result = getValue(a) > getValue(b) ? 1 : -1
      return result * dir;
    }
  }

  export default {
    computed: {
      filteredInvestments() {
        const filtered = this.investments.filter(i => {
          if (this.statusFilter === 'all') {
            return i.status !== 'rejected';
          }

          return i.status === this.statusFilter
        }).filter(i => {
          if (this.search === '') {
            return true;
          }

          const re = new RegExp(this.search, "i");

          return re.test(i.investor.full_name) || re.test(i.subscriber_name);
        });

        const sort = this.columns[this.sortBy].sort;
        const sorted = filtered.sort(by(sort, this.sortDir));

        return sorted
      }
    },
    methods: {
      money(amount) {
        return accounting.formatMoney(amount)
      },
      date(date) {
        if (!date) {
          return ''
        }

        return moment(date).format('MMM DD YYYY - HH:mm:ss')
      },
      statusString(status) {
        let statusString = '';

        for (var group in this.statusGroups) {
          for (var match in this.statusGroups[group].statuses) {
            if (status == match) {
              statusString = this.statusGroups[group].statuses[match]
            }
          }
        }

        return statusString
      },
      dealingRepFormatter(dealingRep) {
        if (!dealingRep) {
          return ""
        } else {
          return dealingRep.full_name
        }
      },
      sort(column) {
        if (this.sortBy == column) {
          this.sortDir *= -1;
        }

        this.sortBy = column;
      },
      saveFilter(status) {
        let statusObj = {filter: status};
        window.history.pushState(
          statusObj,
          status,
          `/admin/${this.activeEmd.slug}/console?filter=${status}`
        )
      }
    },
    props: ['filter'],
    data() {
      return {
        investments: investments,
        activeEmd: activeEmd,
        statusFilter: this.filter,
        sortBy: 'amount',
        sortDir: 1,
        search: '',
        statusGroups: {
          All: {
            name: 'Unfiltered',
            statuses: {
              'all': 'All'
            }
          },
          Pre: {
            name: 'Pre-Sign',
            statuses: {
              'incomplete': 'Incomplete',
              'in progress': 'In Progress',
              'pending signature': 'Pending Signature'
            }
          },
          Post: {
            name: 'Post-Sign',
            statuses: {
              'pending approval': 'Pending Approval',
              'pending funding' : 'Pending Funding',
              'pending close': 'Pending Close',
            }
          },
          Marked: {
            name: 'Marked',
            statuses: {
              'complete': 'Complete',
              'cancelled': 'Cancelled',
              'rejected': 'Rejected',
              'counter signed': 'Counter Signed'
            }
          },
        },
        columns: {
          status: {
            label: 'Status',
            sort: i => i.status
          },
          amount: {
            label: 'Amount',
            sort: i => +i.amount
          },
          signed_on: {
            label: 'Date Submitted',
            sort: i => moment(i.signed_on).format('YYYYMMDD')
          },
          offering: {
            label: 'Offering',
            sort: i => i.offering.name
          },
          account: {
            label: 'Account',
            sort: i => i.investor.full_name
          },
          subscriber: {
            label: 'Subscriber',
            sort: i => i.subscriber_name
          },
        }
      }
    }
  }
</script>
